import { Box, Button, Flex, NumberInput, Select, Stack } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';

import { useRef } from 'react';
import { CA_STATES, COUNTRY_CODES, CURRENCIES, US_STATES } from '../../config';
import { useDataUploadForm, useSandboxUiContext, useUploadAnonData } from '../../hooks';

export const DataUpload = () => {
  const today = useRef(new Date());
  const uploadDataForm = useDataUploadForm();

  const uploadData = useUploadAnonData();
  const sandboxUiContext = useSandboxUiContext();
  const rerenderCta = sandboxUiContext?.rerenderCta as () => Promise<void>;

  const handleUpload = () => {
    if (!uploadDataForm.validate().hasErrors) {
      uploadData.mutate(uploadDataForm.values, {
        onSuccess: async () => {
          await rerenderCta();
        },
        onError: (error) => {
          console.error('Failed to upload data', error);
        },
      });
    }
  };

  return (
    <>
      <Box px={20} py={16} bg="white" style={{ overflowY: 'auto' }}>
        <Stack gap="sm">
          <Select
            label="Currency"
            placeholder="Enter Currency"
            searchable
            data={CURRENCIES}
            comboboxProps={{
              withinPortal: false,
            }}
            {...uploadDataForm.getInputProps('currency')}
          />
          <NumberInput
            label="Annual Revenue"
            allowNegative={false}
            placeholder="Enter Annual Revenue"
            hideControls
            {...uploadDataForm.getInputProps('annual_revenue')}
          />
          <DatePickerInput
            valueFormat="YYYY-MM-DD"
            label="Incorporation Date"
            placeholder="yyyy-mm-dd"
            maxDate={today.current}
            clearable
            popoverProps={{
              withinPortal: false,
            }}
            {...uploadDataForm.getInputProps('incorporation_date')}
          />
          <DatePickerInput
            valueFormat="YYYY-MM-DD"
            label="Client Onboarding Date"
            placeholder="yyyy-mm-dd"
            maxDate={today.current}
            clearable
            popoverProps={{
              withinPortal: false,
            }}
            {...uploadDataForm.getInputProps('client_onboarding_date')}
          />
          <Select
            label="Country"
            placeholder="Enter Country"
            searchable
            data={COUNTRY_CODES}
            comboboxProps={{
              withinPortal: false,
            }}
            {...uploadDataForm.getInputProps('country')}
            onChange={(event) => uploadDataForm.setValues({ country: event ?? '', state: '' })}
          />

          {uploadDataForm.values.country === 'US' && (
            <Select
              label="State"
              placeholder="Enter State"
              searchable
              data={US_STATES}
              comboboxProps={{
                withinPortal: false,
              }}
              {...uploadDataForm.getInputProps('state')}
            />
          )}

          {uploadDataForm.values.country === 'CA' && (
            <Select
              label="Province"
              placeholder="Enter Province"
              searchable
              data={CA_STATES}
              comboboxProps={{
                withinPortal: false,
              }}
              {...uploadDataForm.getInputProps('state')}
            />
          )}
        </Stack>
      </Box>
      <Flex direction="column" bg="white" px={16} py={14} gap="sm" mt="auto" style={{ borderRadius: '0 0 12px 12px' }}>
        <Button onClick={handleUpload} variant="primary" fullWidth>
          Upload data
        </Button>
      </Flex>
    </>
  );
};
